import { render } from "./vdvcorderrankingfd.vue?vue&type=template&id=45babb25&scoped=true"
import script from "./vdvcorderrankingfd.vue?vue&type=script&lang=js"
export * from "./vdvcorderrankingfd.vue?vue&type=script&lang=js"

import "./vdvcorderrankingfd.vue?vue&type=style&index=0&id=45babb25&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45babb25"]])

export default __exports__